import cx from "classnames";
import PropTypes from "prop-types";
import React, { createElement } from "react";

const Loader = ({ as: type, className, ...props }) =>
    createElement(
        type,
        { className: cx("spinner-wrapper", className), ...props },
        <span className="spinner">
            <span />
            <span />
            <span />
        </span>
    );

Loader.defaultProps = {
    as: "div",
    className: "",
};

Loader.propTypes = {
    as: PropTypes.string,
    className: PropTypes.string,
};

export default Loader;
